import { WeaTools } from 'ecCom';
export const newUrl = '/api/cube/mindMap/'
export const CallAPI = (url, method, params) => {
    return new Promise((resolve, reject) => {
        WeaTools.callApi(url, method, params).then(({ noRight, ...data }) => {
            if (noRight) {
                resolve({ noRight, ...data } as any)
            } else {
                resolve(data as any)
            }
        })
    })
}


export const getDatas = (params) => {
    return CallAPI(`${newUrl}datas`, "get", params);
}

export const getNodeHref = (params) => {
    return CallAPI(`${newUrl}getNodeHref`, "get", params);
}

export const getRightMenus = (params) => {
    return CallAPI(`${newUrl}getRightMenus`, "get", params);
}

export const getMindInfoAndNodeStyle = (params) => {
    return CallAPI(`${newUrl}getMindInfoAndNodeStyle`, "get", params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/apis/mindMap.ts